import Configuration from '@/agilis/util/Configuration'
import DataTableV2Paginated from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated.vue'
import Title from '@/agilis/components/Title/Title.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerTable',

  props: {
    propTitle: String
  },

  components: {
    DataTableV2Paginated,
    Title
  },

  data: () => ({
    api: '/api/sales/company'
  }),

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),

    salesApplicationExists () {
      return Configuration.getApplication('sales')
    },

    configuration () {
      return Configuration.datatable.getDatatable({
        applicationId: 'sales',
        trackerTypeId: 'company'
      })
    },

    computedDescription () {
      return this.$t('sales.label.customerDescription')
    }

  }
}
